var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "28px",
    height: "28px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#6b7280",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,6c-2.4675,0 -4.5,2.0325 -4.5,4.5v7c0,2.4675 2.0325,4.5 4.5,4.5h7c2.4675,0 4.5,-2.0325 4.5,-4.5v-7c0,-2.4675 -2.0325,-4.5 -4.5,-4.5zM30.5,6c-2.4675,0 -4.5,2.0325 -4.5,4.5v7c0,2.4675 2.0325,4.5 4.5,4.5h7c2.4675,0 4.5,-2.0325 4.5,-4.5v-7c0,-2.4675 -2.0325,-4.5 -4.5,-4.5zM10.5,9h7c0.8465,0 1.5,0.6535 1.5,1.5v7c0,0.8465 -0.6535,1.5 -1.5,1.5h-7c-0.8465,0 -1.5,-0.6535 -1.5,-1.5v-7c0,-0.8465 0.6535,-1.5 1.5,-1.5zM30.5,9h7c0.8465,0 1.5,0.6535 1.5,1.5v7c0,0.8465 -0.6535,1.5 -1.5,1.5h-7c-0.8465,0 -1.5,-0.6535 -1.5,-1.5v-7c0,-0.8465 0.6535,-1.5 1.5,-1.5zM12,12v4h4v-4zM32,12v4h4v-4zM10.5,26c-2.4675,0 -4.5,2.0325 -4.5,4.5v7c0,2.4675 2.0325,4.5 4.5,4.5h7c2.4675,0 4.5,-2.0325 4.5,-4.5v-7c0,-2.4675 -2.0325,-4.5 -4.5,-4.5zM26,26v5.5h5.5v-5.5zM31.5,31.5v5h5v-5zM36.5,31.5h5.5v-5.5h-5.5zM36.5,36.5v5.5h5.5v-5.5zM31.5,36.5h-5.5v5.5h5.5zM10.5,29h7c0.8465,0 1.5,0.6535 1.5,1.5v7c0,0.8465 -0.6535,1.5 -1.5,1.5h-7c-0.8465,0 -1.5,-0.6535 -1.5,-1.5v-7c0,-0.8465 0.6535,-1.5 1.5,-1.5zM12,32v4h4v-4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.2bb9996f00926def8c373c129bd67ef3.svg";
export { ForwardRef as ReactComponent };